import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
    selector: '[appInViewport]',
    standalone: false
})
export class InViewportDirective implements AfterViewInit, OnDestroy {
  @Output() visibleChange = new EventEmitter<boolean>();

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.visibleChange.emit(entry.isIntersecting);
      },
      { threshold: [0] } // threshold 0: cuando cualquier parte del elemento entra/sale
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
